<!--
  <div class="content">
    <div style="background: white">
      <p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>

    </div>
  </div>
--->
<router-outlet></router-outlet>

<p-confirmDialog [header]="'CONFIRMATION'|translate" icon="pi pi-exclamation-triangle"></p-confirmDialog>

